import { ERROR, RESET, TOGGLE_CANCEL_PRESSED } from './NewServiceConstants'

export function reset() {
  return {
    type: RESET,
  }
}
export function setError(code = '', extra = null) {
  return {
    type: ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function toggleCancelPressed(isCancelled) {
  return {
    type: TOGGLE_CANCEL_PRESSED,
    payload: isCancelled,
  }
}
